import axios from "axios";
import { API_HOST } from "./config";

const axiosInstance = axios.create({
  baseURL: API_HOST,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const accessToken = getAccessTokenFromSessionStorage();

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

function getAccessTokenFromSessionStorage() {
  for (const key of Object.keys(sessionStorage)) {
    const raw = sessionStorage.getItem(key);
    if (!raw) continue;

    try {
      const value = JSON.parse(raw);

      if (value.credentialType === "AccessToken") {
        return value.secret; // <-- this is the token you see
      }
    } catch {
      // ignore non-JSON entries
    }
  }
  return null;
}


export default axiosInstance;